var _g, _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlUsdt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1671_216)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "#4F9E7D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.2028 24.3964V21.0692H37.8162V15.9955H17.0867V21.0692H24.7002V24.395C18.5127 24.6791 13.8594 25.9053 13.8594 27.3735C13.8594 28.8416 18.5127 30.0664 24.7002 30.3519V41.0141H30.2028V30.3491C36.3805 30.065 41.0225 28.8402 41.0225 27.3735C41.0225 25.9067 36.3805 24.6819 30.2028 24.3964ZM30.2028 29.442V29.4449C35.6591 29.203 39.7302 28.2538 39.7302 27.1147C39.7302 25.9785 35.6591 25.0264 30.2028 24.7831V28.4999C30.0439 28.5139 29.1931 28.5842 27.4958 28.5842C26.0811 28.5842 25.0573 28.5238 24.7002 28.4985V24.7803C19.2327 25.025 15.1517 25.977 15.1517 27.1147C15.1517 28.2538 19.2327 29.2058 24.7002 29.4463V29.442C25.0517 29.4589 26.0516 29.5011 27.4719 29.5011C29.2508 29.5011 30.0481 29.4533 30.2028 29.442Z",
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 38,
    width: 14,
    height: 14,
    rx: 7,
    fill: "#F88545"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.5646 41.5575C44.4089 41.7132 44.1418 41.7605 43.9861 41.6048L43.3096 40.9284C43.1385 40.7573 42.8611 40.7573 42.69 40.9284L42.0136 41.6048C41.8579 41.7605 41.5907 41.7132 41.435 41.5575C40.9165 41.0389 40.0757 41.0389 39.5572 41.5575C39.0387 42.076 39.0387 42.9167 39.5572 43.4352C39.7129 43.5909 39.7603 43.8581 39.6046 44.0138L38.9281 44.6902C38.757 44.8613 38.757 45.1388 38.9281 45.3099L39.6046 45.9863C39.7603 46.142 40.0274 46.0946 40.1831 45.9389C40.7017 45.4204 41.5424 45.4204 42.0609 45.9389C42.5795 46.4575 42.5794 47.2982 42.0609 47.8167C41.9052 47.9724 41.8579 48.2396 42.0136 48.3953L42.69 49.0717C42.8611 49.2428 43.1385 49.2428 43.3096 49.0717L43.9861 48.3953C44.1418 48.2396 44.4089 48.2869 44.5646 48.4426C45.0832 48.9612 45.9239 48.9612 46.4424 48.4426C46.9609 47.9241 46.9609 47.0834 46.4424 46.5649C46.2867 46.4092 46.2393 46.142 46.395 45.9863L47.0715 45.3099C47.2426 45.1388 47.2426 44.8613 47.0715 44.6902L46.395 44.0138C46.2393 43.8581 46.2867 43.5909 46.4424 43.4352C46.9609 42.9167 46.9609 42.076 46.4424 41.5575C45.9239 41.0389 45.0832 41.0389 44.5646 41.5575Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1671_216"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlUsdt);
export default __webpack_public_path__ + "static/media/PL-USDT.6a7242ce2138f2fd44a81954777aad46.svg";
export { ForwardRef as ReactComponent };